import cx from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@dropbox/dig-components/buttons';
import { UIIcon } from '@dropbox/dig-icons';
import { ShowLine } from '@dropbox/dig-icons/assets';
import { areToolsHiddenAtom } from 'js/file_viewer/core/atoms/ui/general';
import { useSetFileViewerAtom } from 'js/file_viewer/core/atoms/use_atom';
import { useStabilizedCallback } from 'js/file_viewer/core/utils/useStabilizedCallback';
import { useMouseActive } from 'js/file_viewer/hooks/use_mouse_active';
import { SHOW_TOOLS_HIDE_AFTER_MS } from 'js/file_viewer/ui/constants';
import * as css from 'js/file_viewer/ui/show_tools_button.module.css';
export const ShowToolsButton = () => {
    const intl = useIntl();
    const setAreToolsHidden = useSetFileViewerAtom(areToolsHiddenAtom);
    const { isUserInteractingWithElement, handleBlur, handleFocus } = useMouseActive(SHOW_TOOLS_HIDE_AFTER_MS);
    const onClick = useStabilizedCallback(() => {
        setAreToolsHidden(false);
    });
    return (React.createElement("div", { className: cx(css.showTools, {
            [css.hidden]: !isUserInteractingWithElement,
        }), onFocus: handleFocus, onBlur: handleBlur },
        React.createElement(Button, { variant: "opacity", withIconLeft: React.createElement(UIIcon, { src: ShowLine }), onClick: onClick }, intl.formatMessage({ id: "vQPZmq", defaultMessage: "Show tools" }))));
};
ShowToolsButton.displayName = "ShowToolsButton"
//# sourceMappingURL=show_tools_button.preenvesnextjs.map
